import React from 'react';
import SearchBar from './OzoSearch';
import 'font-awesome/css/font-awesome.min.css';
import './OzoSearch.css';
//import Form from './signup';



function App() {
  return (
    <div className="App">
      <div id="search_div">
        <SearchBar />
      
      </div>
    </div>
    );
}



export default App;
